import { AccountSource } from 'owa-graph-schema';
import { action } from 'satcheljs';

export default action('setInitialAccountSourceList', (sources: AccountSource[]) => ({
    sources,
}));
